<template>
    <div>
        <div class="modal-header">
            <button type="button" class="close" @click="hideModal()" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">Edytuj posiłek {{day.date | format_date}} - {{plan.name}}</h4>
        </div>
        <div class="modal-body">
            <div class="row" v-if="$v.time.$error || $v.name.$error || $v.kcal.$error">
                <div class="col-xs-12">
                    <div class="alert alert-danger">
                        <div class="" v-if="!$v.time.required && $v.time.$error">
                            Godzina jest wymagana.
                        </div>
                        <div class="" v-if="!$v.name.required && $v.name.$error">
                            Nazwa posiłku jest wymagana.
                        </div>
                        <div class="" v-if="!$v.name.minLength && $v.name.$error">
                            Nazwa posiłku musi mieć przynajmniej {{$v.name.$params.minLength.min}} znaków.
                        </div>
                        <div class="" v-if="!$v.kcal.required && $v.kcal.$error">
                            Kaloryczność jest wymagana.
                        </div>
                        <div class="" v-if="!$v.kcal.between && $v.kcal.$error">
                            Kaloryczność musi zawierać się w granicach {{$v.kcal.$params.between.min}}
                            - {{$v.kcal.$params.between.max}} kcal.
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-3">
                    <label>Godzina</label>
                    <div class="form-group"
                         :class="{ 'form-group--error': $v.time.$error }">
                        <input type="time" class="form-control form-control-xs" v-model.trim="$v.time.$model">
                    </div>
                </div>
                <div class="col-xs-6">
                    <label>Nazwa</label>
                    <div class="form-group"
                         :class="{ 'form-group--error': $v.name.$error }">
                        <input type="text" class="form-control form__input form-control-xs"
                               v-model.trim="$v.name.$model">
                    </div>
                </div>
                <div class="col-xs-3">
                    <label>Kaloryczność</label>
                    <div class="form-group"
                         :class="{ 'form-group--error': $v.kcal.$error }">
                        <input type="number" class="form-control form__input form-control-xs"
                               min="1" step="1"
                               v-model.trim="$v.kcal.$model">
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn btn-default" @click="hideModal">Zamknij</button>
            <button class="btn btn-primary btn-success pull-right" @click="save" :disabled="this.$v.$invalid">Zapisz
            </button>
        </div>
    </div>
</template>

<style scoped>
    .in {
        display: block;
    }
</style>
<script>
  import { mapGetters, mapMutations, mapState } from 'vuex';
  import { between, minLength, required } from 'vuelidate/lib/validators';

  export default {
    data() {
      return {
        plan: null,
        dayId: null,
        day: null,
        time: null,
        name: null,
        kcal: null,
      };
    },
    computed: {
      ...mapState({
        modalData: state => state.modal.data,
      }),
      ...mapGetters([
        'getDayById',
        'getPlanById',
      ]),
    },
    methods: {
      ...mapMutations([
        'hideModal',
        'checkPlanRepetition',
      ]),
      getPlan(dayId, planId) {
        return this.getPlanById(dayId, planId);
      },

      save() {
        const checkPlanRepetition = this.plan.time !== this.time;
        if (checkPlanRepetition) {
          this.checkPlanRepetition(this.plan);
        }

        this.plan.name = this.name;
        this.plan.time = this.time;
        this.plan.prescribedEnergy.amount = this.kcal;

        if (checkPlanRepetition) {
          this.checkPlanRepetition(this.plan);
        }

        this.hideModal();
      },
    },
    watch: {
      modalData: {
        immediate: true,
        handler: function(data) {
          if (!data) return;
          this.plan = this.getPlan(data.dayId, data.plan);
          this.dayId = data.dayId;
          this.day = this.getDayById(this.dayId);
          this.time = this.plan.time;
          this.name = this.plan.name;
          this.kcal = this.plan.prescribedEnergy.amount;
        },
      },

      time(value) {
        this.time = value.replace(';', ':')
      }
    },
    validations: {
      time: {
        required,
        regex: (value) => /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(value)
      },
      name: {
        required,
        minLength: minLength(4),
      },
      kcal: {
        required,
        between: between(5, 3000),
      },
    },
  };
</script>
